export enum ImageUpdateStatus {
    NotUploaded = 0,
    InProgress = 1,
    Success = 2,
    Error = 3,
}
